import { createContext, useContext } from 'react';

/** A render root inside a stack page's `FocusScope`. */
export const StackPagePortalContext = createContext<HTMLElement | null>(null);

export const useStackPagePortalTarget = (): HTMLElement | null =>
  useContext(StackPagePortalContext);
